module.exports = __webpack_public_path__ + "img/frameCardOneImg.7ef5d3fd.png";